'use strict';

var app = require('angular').module('attendance');

app.controller('QueueCtrl', require('./queue'));
app.controller('AdminCtrl', require('./admin'));
app.controller('AuthCtrl', require('./auth'));